<template>
  <el-dialog
    :before-close="handleClose"
    :close-on-click-modal="false"
    :visible.sync="dialogVisible"
    center
    title="答题情况"
    width="100%"
  >
    <div class="AnswerSheet">
      <div class="header">
        <div class="item">
          <div class="circle circle1"></div>
          <div class="text">当前试题</div>
        </div>
        <div class="item">
          <div class="circle circle2"></div>
          <div class="text">未做{{bankdata.length-numcounts}}题</div>
        </div>
        <div class="item">
          <div class="circle circle3"></div>
          <div class="text">已做 {{numcount}}题</div>
        </div>
      </div>
      <div class="body">
        <div :key="index" class="body_item" v-for="(item, index) in answerList">
          <div
            class="title"
            v-if="item.child.length > 0"
          >{{item.name}}（{{ item.min}}-{{ item.max }}）题</div>
          <div class="item_li" v-if="item.child.length > 0">
            <span
              :class="itm.select ?'active': ''"
              :key="index"
              :style="activeindexs == itm.order?'border:1px solid rgb(0, 148, 255)':''"
              @click="getVal(itm)"
              v-for="(itm,index) in item.child"
            >{{itm.order}}</span>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
module.exports = {
  name: 'answer-sheet',
  props: ['bankdata', 'istrues', 'numcount', "activeindex"],
  data: function () {
    return {
      listData: '',
      radio: '',
      img_url: ''
    }
  },
  computed: {
    dialogVisible: function () {
      if (this.istrues) {
        return true
      } else {
        return false
      }
    },
    numcounts: function () {
      return this.numcount
    },
    answerList: function () {
      let answerList = [
        {
          name: '单选题',
          child: [],
          min: "",
          max: ""
        },
        {
          name: '多选题',
          child: [],
          min: "",
          max: ""
        },
        {
          name: '判断题',
          child: [],
          min: "",
          max: ""
        },
        {
          name: '简答题',
          child: [],
          min: "",
          max: ""
        }
      ]
      for (let i = 0; i < this.bankdata.length; i++) {
        if (Number(this.bankdata[i].questionType) === 1) {
          answerList[0].child.push(this.bankdata[i])
        } else if (Number(this.bankdata[i].questionType) === 2) {
          answerList[1].child.push(this.bankdata[i])
        } else if (Number(this.bankdata[i].questionType) === 3) {
          answerList[2].child.push(this.bankdata[i])
        } else if (Number(this.bankdata[i].questionType) === 4) {
          answerList[3].child.push(this.bankdata[i])
        }
      }
      for (let s = 0; s < answerList.length; s++) {
        if (answerList[s].child.length > 0) {
          answerList[s].min = answerList[s].child[0].order
          answerList[s].max = answerList[s].child[answerList[s].child.length - 1].order
        }
      }
      return answerList
    },
    activeindexs: function () {
      return this.activeindex
    }
  },
  mounted: function () {
    console.log(this.bankdata, 777777)
  },
  watch: {
  },
  methods: {
    getVal (val) {
      console.log(val,'wwww')
      let obj = {
        q_id: val.q_id,
        order: val.order
      }
      this.$emit('getvalue', obj)
      this.handleClose()
    },
    handleClose: function () {
      this.$emit('getstatus', false)
    }
  }
}
</script>
<style scoped>
.el-dialog__wrapper {
  overflow: visible;
}
.el-dialog {
  height: 85vh;
}
.el-dialog .el-dialog__body {
  position: relative;
}
.el-dialog .el-dialog__body .AnswerSheet {
  height: 85vh;
  left: 0;
  width: 100%;
}
.el-dialog .el-dialog__body .AnswerSheet .header {
  display: flex;
  justify-content: space-around !important;
  margin-top: 1rem;
}
.el-dialog .el-dialog__body .AnswerSheet .header .item {
  width: 30%;
  display: inline-flex;
  align-items: center;
}
.el-dialog .el-dialog__body .AnswerSheet .header .item .circle {
  width: 0.9375rem;
  height: 0.9375rem;
  border-radius: 50%;
  border: 1px solid #0094ff;
  margin-right: 0.3125rem;
}
.el-dialog .el-dialog__body .AnswerSheet .header .item .circle2 {
  border: 1px solid #cccccc;
}
.el-dialog .el-dialog__body .AnswerSheet .header .item .circle3 {
  border: 1px solid #e0f2ff;
  background-color: #e0f2ff;
}
.el-dialog .el-dialog__body .AnswerSheet .body {
  padding: 1%;
  height: 68vh;
  overflow-y: scroll;
}
.el-dialog .el-dialog__body .AnswerSheet .body .body_item {
  margin-top: 0.75rem;
}
.el-dialog .el-dialog__body .AnswerSheet .body .body_item .title {
  margin: 0.75rem 0;
  font-size: 0.875rem;
}
.el-dialog .el-dialog__body .AnswerSheet .body .body_item .item_li {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.el-dialog .el-dialog__body .AnswerSheet .body .body_item .item_li span {
  width: 2.8125rem;
  height: 2.8125rem;
  border-radius: 50%;
  border: 1px solid #cccccc;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 3%;
  margin-bottom: 3%;
  cursor: pointer;
}
/* .el-dialog
  .el-dialog__body
  .AnswerSheet
  .body
  .body_item
  .item_li
  span:nth-child(6n-5) {
  margin-left: 3%;
} */
.el-dialog .el-dialog__body .AnswerSheet .body .body_item .item_li .active {
  border: 1px solid #e0f2ff;
  background-color: #e0f2ff;
  color: #0094ff;
}
.el-dialog .el-dialog__body .AnswerSheet .body .body_item .item_li .actives {
  border: 1px solid #0094ff;
}
.el-dialog--center .el-dialog__body {
  padding: 0;
}
</style>